import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { Close as CloseIcon } from '@mui/icons-material';
import "./FilterButton.scss";

export default function FilterButton({ label, icon, inputs, setDefaultFilter }) {
    const [isSelected, setIsSelected] = useState(false);
    const [selectedLabel, setSelectedLabel] = useState();
    const [selectedIcon, setSelectedIcon] = useState();
    const filterDefault = inputs.props.fields[0].default;

    useEffect(() => {
        if (inputs) {
            const selected = inputs.props.fields[0].radio.some(r => r.selected === true);
            const current = inputs.props.fields[0].radio.find(r => r.selected);

            setIsSelected(selected);
            if (current !== undefined) {
                setSelectedLabel(current.label);
                setSelectedIcon(current.icon);
            };
        };
    }, [inputs]);
    return (
        <button className={`filter-select ${isSelected ? "selectedFilterBackground filtering" : ""}`}>
            {isSelected ? selectedIcon : icon}<span>{isSelected ? selectedLabel : label}</span>
            {isSelected && <span className="filter-reset" onClick={() => { setDefaultFilter(filterDefault) }}><CloseIcon style={{ fontSize: 14 }} /></span>}
            <div className="input-container">
                {inputs}
            </div>
        </button>
    )
}

FilterButton.propTypes = {
    label: PropTypes.string.isRequired,
    icon: PropTypes.element.isRequired,
    inputs: PropTypes.element.isRequired,
    setDefaultFilter: PropTypes.func.isRequired,
};
